import AtApi from './AtApi';

// Each vehicle returned by serviceinfo/v1/vehicles/byTripId is a 3-car EMU unit.
const CARRIAGES_PER_VEHICLE = 3;

export const shouldDisplayCarriageCount = (count) => (
  typeof count === 'number' && count > 0 && count % CARRIAGES_PER_VEHICLE === 0
);

export const mapVehiclesToCarriageCount = (vehicles) => {
  if (!Array.isArray(vehicles) || vehicles.length === 0) {
    return null;
  }

  return vehicles.length * CARRIAGES_PER_VEHICLE;
};

export const formatCarriageCountLabel = (count) => (
  shouldDisplayCarriageCount(count) ? `${count} carriages` : null
);

const requestCarriageCount = (tripId) => (
  AtApi.getInstance().getVehiclesByTripId(tripId)
    .then((vehicles) => mapVehiclesToCarriageCount(vehicles))
    .catch(() => null)
);

export const fetchCarriageCounts = (tripIds) => {
  const uniqueIds = [...new Set((tripIds || []).filter(Boolean))];

  return Promise.all(uniqueIds.map(async (tripId) => [tripId, await requestCarriageCount(tripId)]))
    .then((entries) => entries.reduce((counts, [tripId, count]) => {
      if (count != null) {
        counts[tripId] = count;
      }
      return counts;
    }, {}));
};
